import { Wallet } from './wallet';

export enum FundType {
  FUND_ONE = 'Fund I',
  FUND_TWO = 'Fund II (GromaREIT)',
}

export interface Account {
  id: number;
  name: string;
  fund?: FundType;
  wallet: Wallet;
  created_at: string;
  updated_at: string;
}
